/**
 * Validate Vietnamese phone number format
 * Supports formats: 0123456789, 0912345678, +84123456789, 84123456789
 */
export const validateVietnamesePhone = (phoneNumber) => {
  // Remove all non-digit characters except +
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  
  // Vietnamese phone number patterns
  const patterns = [
    /^0[3|5|7|8|9][0-9]{8}$/, // 03x, 05x, 07x, 08x, 09x
    /^\+84[3|5|7|8|9][0-9]{8}$/, // +84 + 3x, 5x, 7x, 8x, 9x
    /^84[3|5|7|8|9][0-9]{8}$/, // 84 + 3x, 5x, 7x, 8x, 9x
  ];
  
  return patterns.some(pattern => pattern.test(cleaned));
};

/**
 * Format phone number to standard Vietnamese format
 */
export const formatVietnamesePhone = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  
  // If starts with +84, keep as is
  if (cleaned.startsWith('+84')) {
    return cleaned;
  }
  
  // If starts with 84, add +
  if (cleaned.startsWith('84')) {
    return `+${cleaned}`;
  }
  
  // If starts with 0, convert to +84
  if (cleaned.startsWith('0')) {
    return `+84${cleaned.substring(1)}`;
  }
  
  return cleaned;
};

/**
 * Get phone number without country code
 */
export const getLocalPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  
  if (cleaned.startsWith('+84')) {
    return `0${cleaned.substring(3)}`;
  }
  
  if (cleaned.startsWith('84')) {
    return `0${cleaned.substring(2)}`;
  }
  
  return cleaned;
}; 